import i18n from "@/i18n"

const Home = () => import(/* webpackChunkName: "home" */ '@/views/Home')
const TpvCallback = () => import(/* webpackChunkName: "tpvcallback" */ '@/views/TpvCallback')
const TpvOK = () => import(/* webpackChunkName: "tpvok" */ '@/views/TpvOk')
const TpvKO = () => import(/* webpackChunkName: "tpvko" */ '@/views/TpvKo')
const IbanOk = () => import(/* webpackChunkName: "ibanok" */ '@/views/IbanOk')
const Login = () => import(/* webpackChunkName: "login" */ '@/views/Login')
const GenerarContrasena = () => import(/* webpackChunkName: "generarcontrasena" */ '@/views/GenerarContrasena')
const OlvidoContrasena = () => import(/* webpackChunkName: "generarcontrasena" */ '@/views/OlvidoContrasena')
const NotFound = () => import(/* webpackChunkName: "notfound" */ '@/views/NotFound')

const locale = i18n.locale

const routes = [
    { 
        path: '/', 
        name:'ini',
        component: Login,
        redirect: `/${locale}`,
        
    },
    {
        path: '/:locale',
        component: {
            render (c) { return c('router-view') }
        },
        children: [
            { 
                path: '', 
                name:'login',
                component: Login,
            },
            { 
                path: 'home', 
                name:'home',
                component: Home,
                // This route requires authentication
                meta: { requiresAuth: true }
            },
            { 
                path: 'iban-ok', 
                name:'ibanok',
                component: IbanOk,
                // This route requires authentication
                meta: { requiresAuth: true }
            },
            { 
                path: 'tpv-callback', 
                name:'tpv-callback',
                component: TpvCallback,
            },
            { 
                path: 'tpv-pago-ok', 
                name:'tpv-pago-ok',
                component: TpvOK,
            },
            { 
                path: 'tpv-pago-ko', 
                name:'tpv-pago-ko',
                component: TpvKO,
            },
            {
                path: "generar-contrasena/:token",
                name: "GenerarContrasena",
                component: GenerarContrasena
            },
            {
                path: "olvido-contrasena",
                name: "OlvidoContrasena",
                component: OlvidoContrasena
            },
            {
                path: "404",
                alias: '*',
                name: "NotFound",
                component: NotFound
            }
        ]
    }
    
]

export default routes